export const checkmarkThinIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M1 8.333 2.4 7l3.5 3.333L13.6 3 15 4.333 5.9 13z"/></svg>`,
    name: 'checkmark-thin' as const
};